module.exports = __webpack_public_path__ + "img/loginBanner.b1b6d8ab.png";